import { DataFormat } from '../DataFormat';
import { defaultFormat } from '../defaultDataFormat';
import { SeriesFormat } from './DoughnutChart.series';
import { SingleValueChartData } from '../../../models/SingleValueChartData';
import { ITooltip } from '../ITooltip';

export function map<TValues>(series: SeriesFormat[],
    data: TValues[],
    options: { dataFormat: DataFormat<SeriesFormat, TValues> } & ITooltip<SeriesFormat, TValues>): SingleValueChartData[] {
    const { dataFormat } = options;
    const { value, identifier, label } = dataFormat;

    return series.map(s => {
        const id = identifier(s);
        const currentData = data.filter(d => identifier(d) === id);
        const v = currentData && currentData.length ? value(currentData[0]) : 1e-12;
        const rawColor = s.color;
        const format = s.format || defaultFormat;
        const classes = [];
        return {
            id,
            label: label(s),
            value: v,
            formattedValue: format(v),
            color: rawColor,
            labelColor: rawColor,
            attributes: s.attributes,
            clickCallback: s.clickCallback,
            classes,
            tooltip: options.tooltip && options.tooltip.isVisible
                ? options.tooltip.format(s, currentData[0])
                : null
        };
    });
}
